import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
} from '@mui/material';

const ViewHCP = ({ open, onClose, hcpData }) => {
    if (!hcpData) return null;

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle className="bg-blueColor text-white py-4">
                <i className="fas fa-eye text-xl mx-2"></i>
                <span className="text-xl font-semibold">View HCP Details</span>
            </DialogTitle>
            <DialogContent className="mt-4">
                <div className="grid grid-cols-2 gap-4 p-4">
                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            First Name
                        </label>
                        <div className="w-full p-2 border rounded bg-gray-50">
                            {hcpData?.first_name || 'N/A'}
                        </div>
                    </div>

                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Family Name
                        </label>
                        <div className="w-full p-2 border rounded bg-gray-50">
                            {hcpData?.family_name || 'N/A'}
                        </div>
                    </div>

                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Email
                        </label>
                        <div className="w-full p-2 border rounded bg-gray-50">
                            {hcpData?.email || 'N/A'}
                        </div>
                    </div>

                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Phone Number
                        </label>
                        <div className="w-full p-2 border rounded bg-gray-50">
                            {hcpData?.phone_number || 'N/A'}
                        </div>
                    </div>

                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Specialty
                        </label>
                        <div className="w-full p-2 border rounded bg-gray-50">
                            {hcpData?.specialty || 'N/A'}
                        </div>
                    </div>

                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Organization
                        </label>
                        <div className="w-full p-2 border rounded bg-gray-50">
                            {hcpData?.organization || 'N/A'}
                        </div>
                    </div>

                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Medical License
                        </label>
                        <div className="w-full p-2 border rounded bg-gray-50">
                            {hcpData?.medical_license || 'N/A'}
                        </div>
                    </div>

                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            National ID
                        </label>
                        <div className="w-full p-2 border rounded bg-gray-50">
                            {hcpData?.national_id || 'N/A'}
                        </div>
                    </div>

                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            APO Number
                        </label>
                        <div className="w-full p-2 border rounded bg-gray-50">
                            {hcpData?.APO_number || 'N/A'}
                        </div>
                    </div>

                    <div>
                        <label className="block text-gray-700 text-sm font-bold mb-2">
                            Industry Area
                        </label>
                        <div className="w-full p-2 border rounded bg-gray-50">
                            {hcpData?.industry_area || 'N/A'}
                        </div>
                    </div>
                </div>
                <div className="flex justify-end gap-4 mt-6 p-4">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
                    >
                        Close
                    </button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default ViewHCP; 